import { useCallback, useEffect, useRef } from 'react';

const OFFER_SID = 'hfbfec';
const EVENT_SID = 'v4e9fd';

// https://targetcircle.com/blog/automatic-article/installing-first-party-tracking-v2/

export const useSaleTracker = () => {
  const script = useRef<HTMLScriptElement>();

  const track = useCallback(
    async ({
      id,
      amount,
      currency,
      code
    }: {
      id?: string;
      amount?: string;
      currency?: string;
      code?: string;
    }) => {
      if (script.current) {
        document.body.removeChild(script.current);
        script.current = undefined;
      }
      try {
        script.current = document.createElement('script');
        script.current.setAttribute('src', '//cdn.trackmytarget.com/tracking/s/checkout.min.js');
        script.current.setAttribute('data-type', 'sale');
        script.current.setAttribute('data-offer-sid', OFFER_SID);
        script.current.setAttribute('data-event-sid', EVENT_SID);
        id && script.current.setAttribute('data-id', id);
        amount && script.current.setAttribute('data-amount', amount);
        currency && script.current.setAttribute('data-currency', currency);
        code && script.current.setAttribute('data-code', code);

        script.current.async = true;

        console.info(`useSaleTracker.track: ${JSON.stringify({ id, amount, currency, code })}`);
        document.body.appendChild(script.current);
      } catch (e) {
        console.error('useSaleTracker.track:', e);
      }
    },
    []
  );

  useEffect(() => {
    return () => {
      if (script.current) {
        document.body.removeChild(script.current);
        script.current = undefined;
      }
    };
  }, []);

  return track;
};
